import { gql } from 'gql/__generated__'

export const templatesGetAllIdsQuery = gql(`
  query TemplatesAllIds($companyId: ID!, $data: EditorTemplateAllInput!) {
    data: editorTemplatesAllIds(companyId: $companyId, data: $data)
  }
`)

export const templatesCreateFromBlock = gql(`
  mutation TemplatesCreateFromBlock($data: EditorTemplateCreateInput!) {
    data: editorTemplateCreateFromBlock(data: $data) {
      data {
        ...TemplatesListSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const templateCopy = gql(`
  mutation TemplateCopy($payload: EditorTemplateMultiCopyInput!) {
    data: editorTemplatesMultiCopy(payload: $payload) {
      ...TemplatesListSchema
    }
  }
`)

export const templatesSave = gql(`
  mutation TemplatesSave($companyId: ID!, $data: EditorTemplateInput!) {
    data: editorTemplatesUpdateById(companyId: $companyId, data: $data) {
      data {
        ...TemplatesListSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const templatesDeleteByIds = gql(`
  mutation TemplatesDeleteByIds($companyId: ID!, $ids: [ID!]!) {
    data: editorTemplatesDeleteByIds(companyId: $companyId, ids: $ids)
  }
`)

export const templatesAddToFavs = gql(`
  mutation TemplatesAddToFavs($companyId: ID!, $projectId: ID, $ids: [ID!]!) {
    data: editorTemplatesFavoritesAdd(companyId: $companyId, ids: $ids, projectId: $projectId) {
      id
      isFavorite
    }
  }
`)

export const templatesRemoveFromFavs = gql(`
  mutation templatesRemoveFromFavs($companyId: ID!, $ids: [ID!]!) {
    data: editorTemplatesFavoritesRemove(companyId: $companyId, ids: $ids) {
      id
      isFavorite
    }
  }
`)

export const templateGroupCreate = gql(`
  mutation EditorTemplateCollectionCreate(
    $companyId: ID!
    $payload: TemplateCollectionCreateInput!
  ) {
    data: templateCollectionCreate(companyId: $companyId, payload: $payload) {
      data {
        ...TemplateCollectionsSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const templateGroupDuplicate = gql(`
  mutation EditorTemplateCollectionDuplicate($companyId: ID!, $id: ID!) {
    data: templateCollectionDuplicate(companyId: $companyId, id: $id) {
      id
      name
    }
  }
`)

export const templateGroupUpdate = gql(`
  mutation EditorTemplateCollectionUpdate($id: ID!, $payload: TemplateCollectionUpdateInput!) {
    data: templateCollectionUpdate(id: $id, payload: $payload) {
      data {
        ...TemplateCollectionsSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const templateGroupDelete = gql(`
  mutation EditorTemplateCollectionArchive($id: ID!) {
    data: templateCollectionArchive(id: $id)
  }
`)

export const templateTagsCreate = gql(`
  mutation TemplateTagsCreate(
    $collectionId: ID!
    $names: [String!]!
  ) {
    data: templateTagsCreate( collectionId: $collectionId, names: $names) {
      data {
        ...TemplateTagsSchema
      }
      errors {
        ...ErrorSchema
      }
    }
  }
`)

export const templateTagsDelete = gql(`
  mutation TemplateTagsDelete($collectionId: ID!, $ids: [ID!]!, $replacementTemplateTagIds: [ID!]) {
    data: templateTagsDelete(collectionId: $collectionId, ids: $ids, replacementTemplateTagIds: $replacementTemplateTagIds) 
  }
`)

export const templateTagDrag = gql(`
  mutation TemplateTagDrag($id: ID!, $newPosition: Int!) {
    data: templateTagDrag(id: $id, newPosition: $newPosition) {
        ...TemplateTagsSchema
    }
  }
`)

export const templateTagUpdateName = gql(`
  mutation TemplateTagUpdateName($collectionId: ID!, $id: ID!, $name: String!) {
    data: templateTagUpdateName(collectionId: $collectionId, id: $id, name: $name) { 
      ...TemplateTagsSchema
    }
  }
`)
